import React from 'react';

import AddRecipientsForm from 'src/presentation/components/pages/proactiveCommunications/components/shared/AddRecipientsForm';

const AddVoiceRecipientsForm = ({ campaign, item, root, 'data-aid': dataAid }) => {
  const startDateTimeDescription = (
    <>
      Set the date and time when Gladly starts the outbound calls. Calls will only be made within the Campaign
      <br /> schedule hours.
    </>
  );

  return (
    <AddRecipientsForm
      campaign={campaign}
      data-aid={dataAid}
      item={item}
      root={root}
      startDateTimeDescription={startDateTimeDescription}
    />
  );
};

export default AddVoiceRecipientsForm;
